import { apiClient } from "@base/api/client";

export const fetchMembership = async (): Promise<{
  plan_description: {
    type: "SILVER" | "VIRTUAL_ADDRESS" | "DAY_PASS";
    billing_cycle: "YEARLY" | "MONTHLY" | "DAILY";
    amount: string;
  };
  number: string;
  status: "PENDING" | "ACTIVE" | "INACTIVE";
  start_date: string;
  next_payment_date: string;
  unsubscription_requested: boolean;
  end_date: string | null;
}> => {
  const response = await apiClient.get("/82office/membership/api/membership");
  return response.data;
};

export const fetchFinalPaymentAmount = async ({
  type,
  billingCycle,
}: {
  type: "SILVER" | "VIRTUAL_ADDRESS" | "DAY_PASS";
  billingCycle: "MONTHLY" | "YEARLY" | "DAILY";
}): Promise<{
  original_amount: string;
  promotion_amount: string;
  total_amount: string;
}> => {
  const response = await apiClient.get(`/82office/payment/api/membership?type=${type}&billing_cycle=${billingCycle}`);
  return response.data;
};
